export default function ({ route, redirect }) {
  debugger
  return redirect('/d/' + route.params.dropId)
}
